<company-block-card [title]="'LABELS.ORGANIZATION_PROFILE_SETUP_TITLE'" [explanationSubTitle]="'LABELS.PLEASE_FILL_USER_INFO'">
  <form [formGroup]="formGroup" autocomplete="off" *ngIf="isEditView" card-body>
    <div class="organization-details">
      <!--    business info -->
      <section class="form-section" id="organization-business-info-section" *ngIf="!!formGroup">
        <organization-details-form [isEditView]="isEditView" [formGroup]="formGroup" />
      </section>

      <!--    business address -->
      <section class="form-section" id="business-address-section">
        <organization-address-form [formGroup]="formGroup"></organization-address-form>
      </section>

      <!--  contact information -->
      <section class="form-section" id="business-address-section">
        <organization-contact-information-form [formGroup]="formGroup"></organization-contact-information-form>
      </section>
      <!--  organization logo -->
      <section class="form-section" id="organization-logo">
        <organization-logo-form
          [logoUri]="formGroup.get('logoUri')?.value"
          [organizationId]="organizationId"
          (uploadLogoControlSource$)="updateLogoControl($event)"
          (removeLogoSource$)="removeLogo()"
        ></organization-logo-form>
      </section>

      <div class="action-buttons-container">
        <button
          type="button"
          class="action-buttons-container__button action-buttons-container__button-secondary"
          (click)="redirectToOrganizationPage()"
        >
          {{ "BUTTON.CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary action-buttons-container__button action-buttons-container__button-primary"
          [disabled]="formGroup.invalid"
          (click)="updateOrganizationDetails()"
        >
          {{ "BUTTON.SAVE_CHANGES" | translate }}
        </button>
      </div>
    </div>
  </form>
</company-block-card>

<loading-spinner [show]="isLoadingSaveChanges" [config]="{ fullScreenBackdrop: true }"></loading-spinner>
